import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';

@customElement('review-block')
@autoinject
export class ReviewBlockCustomElement extends BaseCustomElement {
    @bindable icon: string;
    @bindable name: string;
    @bindable value: number = null;
}
